import { APP_API_URL } from '../../../utils/xhr-instance';
import { getLocalStorageData } from '../../../utils/helper';
import axiosInstance from '../../../services/axios';
import { setAuthTokenToLocalStorage } from '../../../utils';

export const ORGANISTATION_SETUP_DONE = 'ORGANISTATION_SETUP_DONE';
export const ORGANISTATION_SETUP_FAIL = 'ORGANISTATION_SETUP_DONE';

export const ORGANISTATION_API_URL = `${APP_API_URL}/auth/organisation-setup`;

export const organistation_setup = (formBody) => {
	const token = getLocalStorageData();

	return async (dispatch) => {
		try {
			const res = await axiosInstance.post(ORGANISTATION_API_URL, formBody, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			});

			if (res.data?.success) {
				setAuthTokenToLocalStorage(res.data.token);

				dispatch({
					type: ORGANISTATION_SETUP_DONE,
					payload: res.data,
				});

				return res.data;
			}

			dispatch({
				type: ORGANISTATION_SETUP_FAIL,
				payload: res.data,
			});

			throw res.data;
		} catch (error) {
			dispatch({
				type: ORGANISTATION_SETUP_FAIL,
				payload: error?.response?.data || error,
			});

			throw error?.response?.data || error;
		}
	};
};
